<template functional>
  <kw-button
    button-type="text"
    class="button-closer"
    data-cy="button-closer"
    prepend-icon-class="kw kw-x"
    v-on="listeners"
  />
</template>

<script>
export default {
  name: 'Closer',
  props: {
    closerSize: {
      type: String,
      required: false,
      default: '14',
    },
  },
};
</script>

<style lang="scss" scoped>
.button-closer {
  background: transparent;
  border: none;
  color: #63697b !important;
  outline: transparent !important;
  height: 14px !important;
  padding: 0;

  &:hover {
    color: #909399;
  }
}
</style>
